/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Component } from '@angular/core'
import { ModalController } from '@ionic/angular/standalone'
import { CacheService } from '../services/business/cache.service'
import { ConfigSettingKey, OperatorConfigSettingDto } from '../models/configSettings.model'
import { HtmlContentModalComponent } from '../html-content-modal/html-content-modal.component'
import { environment } from '../../../src/environments/environment'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {

  constructor(
    private modalController: ModalController,
    private cacheService: CacheService
  ) {
    this.links = this.cacheService.getCommonConfigSettings()?.filter(x => x.configKey == ConfigSettingKey.PostLoginFooterHtml)
    this.contactUsLink = this.cacheService.getCommonConfigSettings()?.find(x => x.configKey == ConfigSettingKey.ContactUsHtml)
  }

  appVersion = environment.appVersion
  currentYear = new Date().getFullYear()
  links: OperatorConfigSettingDto[] = []
  contactUsLink: OperatorConfigSettingDto

  async displayModal(link: OperatorConfigSettingDto): Promise<void> {

    const linkModal = await this.modalController.create({
      component: HtmlContentModalComponent,
      componentProps: {
        modalHtmlUrl: link.configValue,
      },
      cssClass: 'html-modal',
    })
    void await linkModal.present()
  }
}
